var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"color":"primary"}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"d-inline-block white--text mb-1"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")]),_c('v-list-item-subtitle',{staticClass:"d-inline-block white--text"},[_vm._v(" ("+_vm._s(_vm.user.rentalcompanyName)+") ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }